import React from "react"
import ReactDOM from "react-dom"
import {RegistrationHeader} from '../components/headers'
import {
    RegistrationHeaderStep1, RegistrationHeaderStep2,
    RegistrationHeaderStep3, RegistrationHeaderStep4
} from "../components/headers";

import {Error as _Error } from "../components/forms";
import { connect } from "react-redux"
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed'


class Error extends React.Component {

    componentDidMount = () => {
        scrollIntoViewIfNeeded(ReactDOM.findDOMNode(this._errorNode), false , {duration: 150});
    };

    componentWillReceiveProps = () => {
        scrollIntoViewIfNeeded(ReactDOM.findDOMNode(this._errorNode), false , {duration: 150});
    }


    render = () => {
        return <_Error ref={(node) => {
            this._errorNode = node}} error={this.props.error}/>
    }
}

Error = connect(state => { return {
    applicationErrors : state.applicationErrors,
} })(Error);

class ScrollToRegistrationHeader extends React.Component {

    render = () => {
        return <RegistrationHeader active={this.props.active} flow={this.props.flow} />
    }
}

class Registration extends React.Component {

    componentDidMount = () => {
        scrollIntoViewIfNeeded(ReactDOM.findDOMNode(this._registrationHeaderNode), false , {duration: 150});
    };

    render = () => {
        const props = this.props;
        const flow = [

            {
                view: <RegistrationHeaderStep1/>,
                index: 0,
            },
            {
                view: <RegistrationHeaderStep2/>,
                index: 1,
            },
            {
                view: <RegistrationHeaderStep3/>,
                index: 2,
            },
            {
                view: <RegistrationHeaderStep4/>,
                index: 3,
            },

        ];

        return (
            <div className="registration-component">

                <ScrollToRegistrationHeader  active={props.active} flow={flow[props.active]} ref={(node) => {
                    this._registrationHeaderNode = node;
                }}/>
                <section className="main-section main-regn-wrapper">
                    {props.error && (props.error.submitted && <section className={"row"}><Error error={props.error}/></section>)}
                    <div className="regn-form-section">
                        {props.children}
                    </div>
                </section>
            </div> )


    }
};

Registration.defaultProps = {
    active : 0
};

export {
    Registration
}